/**
 * Get JWT token from localStorage (Cognito storage)
 * 
 * This function retrieves the JWT token from AWS Cognito's localStorage structure:
 * - First gets the authenticated user from LastAuthUser
 * - Then retrieves the idToken for that user
 * 
 * @returns JWT token string or null if not found
 */
export const getIdTokenFromLocalStorage = (): string | null => {
    if (typeof window === 'undefined') return null;
    
    const clientId = process.env.PUBLIC_USERPOOL_WEB_CLIENT_ID;
    if (!clientId) {
      console.warn('PUBLIC_USERPOOL_WEB_CLIENT_ID not found in environment variables');
      return null;
    }
    
    try {
      const authUser = localStorage.getItem(
        `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`
      );
      
      if (!authUser) {
        console.warn('No authenticated user found in localStorage');
        return null;
      }
      
      const token = localStorage.getItem(
        `CognitoIdentityServiceProvider.${clientId}.${authUser}.idToken`
      );
      
      return token;
    } catch (error) {
      console.warn('Error accessing localStorage:', error);
      return null;
    }
  };

  export const getAuthTokenFromLocalStorage = (): string | null => {
    if (typeof window === 'undefined') return null;
    
    const clientId = process.env.PUBLIC_USERPOOL_WEB_CLIENT_ID;
    if (!clientId) {
      console.warn('PUBLIC_USERPOOL_WEB_CLIENT_ID not found in environment variables');
      return null;
    }
    
    try {
      const authUser = localStorage.getItem(
        `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`
      );
      
      if (!authUser) {
        console.warn('No authenticated user found in localStorage');
        return null;
      }
      
      const token = localStorage.getItem(
        `CognitoIdentityServiceProvider.${clientId}.${authUser}.accessToken`
      );
      
      return token;
    } catch (error) {
      console.warn('Error accessing localStorage:', error);
      return null;
    }
  };
  